// Prints only the element carrying the "print-target" class (see the
// body.printing-invoice rules in main.css), regardless of where it sits in
// the DOM — inside a modal, behind a dashboard layout, etc.
export const printElement = () => {
  document.body.classList.add("printing-invoice");

  const cleanup = () => {
    document.body.classList.remove("printing-invoice");
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);

  window.print();
};
